<template>
  <MaskLayer>
    <Slider class="w-75" @close="close">
      <div class="container-fluid p-0 mw-100 flex-grow-1 overflow-auto">
        <div class="h-100 overflow-auto row no-gutters">
          <div class="col-3 p-0 h-100 overflow-auto">
            <div class="h-100 border-right border-light overflow-auto d-flex flex-column">
              <div class="py-3 px-4">
                <h5 v-t="'admin.companyEdit.title'" />
                <div v-if="!newCompany" class="position-relative">
                  <h5 class="font-size-base p-1 mx-n1 mb-0">
                    {{ company.name }}
                  </h5>
                  <b-form-checkbox v-model="company.status" size="sm" name="check-button" switch class="text-primary">
                    <template v-if="company.status">
                      {{ $t('auth.activating') }}
                    </template>
                    <template v-else>
                      {{ $t('auth.disabled') }}
                    </template>
                  </b-form-checkbox>
                </div>
              </div>
              <div class="px-4 pb-3">
                <b-button
                  v-if="newCompany"
                  :variant="tab === 'NewCompany' ? 'light' : 'outline-light'"
                  class="w-100 py-0 mb-2 d-flex align-items-center text-secondary position-relative"
                  draggable=""
                  @click="tab = 'NewCompany'"
                >
                  <div class="image-panel image-panel-0 bg-none">
                    <i v-if="CompanyInfoValid" class="material-icons-outlined md-18">assessment</i>
                    <i v-else class="material-icons-outlined text-danger">error_outline</i>
                  </div>
                  <span v-t="'admin.companyEdit.companyInfo'" class="font-size-md text-truncate" />
                </b-button>
                <b-button
                  v-if="!newCompany"
                  :variant="tab === 'EditCompany' ? 'light' : 'outline-light'"
                  class="w-100 py-0 mb-2 d-flex align-items-center text-secondary position-relative"
                  draggable=""
                  @click="tab = 'EditCompany'"
                >
                  <div class="image-panel image-panel-0 bg-none">
                    <i v-if="CompanyInfoValid" class="material-icons-outlined md-18">assessment</i>
                    <i v-else class="material-icons-outlined text-danger">error_outline</i>
                  </div>
                  <span v-t="'admin.companyEdit.companyInfo'" class="font-size-md text-truncate" />
                </b-button>
                <b-button
                  :variant="tab === 'CompanyFeature' ? 'light' : 'outline-light'"
                  class="w-100 py-0 mb-2 d-flex align-items-center text-secondary position-relative"
                  draggable=""
                  @click="tab = 'CompanyFeature'"
                >
                  <div class="image-panel image-panel-0 bg-none">
                    <i class="material-icons-outlined md-18">assessment</i>
                  </div>
                  <span v-t="'auth.roleEdit.authority'" class="font-size-md text-truncate" />
                </b-button>
              </div>
            </div>
          </div>
          <NewCompany v-if="newCompany && tab === 'NewCompany'" v-model="newCompanyForm" />
          <EditCompany v-if="!newCompany && tab === 'EditCompany'" v-model="editCompanyForm" />
          <CompanyFeature v-if="tab === 'CompanyFeature'" v-model="company.features" :company-id="company.id" />
        </div>
      </div>
      <FixedBottomBtn class="bg-white p-3">
        <div class="d-flex justify-content-between">
          <div>
            <button
              class="ml-2 btn btn-sm btn-outline-light rounded-pill border-0 d-flex align-items-center"
              :disabled="newCompany"
              :style="deleteButtonStyle"
              @click="deleteCompany"
            >
              <span class="text-secondary material-icons-outlined md-18 mr-1">delete</span>
              <span v-t="'common.delete'" class="text-secondary" />
            </button>
          </div>
          <div>
            <button class="ml-2 btn btn-sm btn-outline-light rounded-pill" @click="close">
              <span v-t="'common.cancel'" class="px-3 text-secondary" />
            </button>
            <button class="ml-2 btn btn-sm btn-success rounded-pill" @click="save">
              <span v-t="'common.save'" class="px-3" />
            </button>
          </div>
        </div>
      </FixedBottomBtn>
    </Slider>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import Slider from '@/components/Slider.vue';
import FixedBottomBtn from '@/components/FixedBottomBtn.vue';
import PermissionService from '@/services/PermissionService';
import CompanyFeature from '@/components/Admin/CompanyFeature.vue';
import NewCompany from '@/components/Admin/NewCompany.vue';
import EditCompany from '@/components/Admin/EditCompany.vue';
import { EmailValidate } from '@/services/AccountService';

export default {
  components: {
    MaskLayer,
    Slider,
    FixedBottomBtn,
    CompanyFeature,
    NewCompany,
    EditCompany
  },
  props: {
    companyId: {
      type: String
    },
    mode: {
      type: String
    }
  },
  data() {
    return {
      company: {
        id: this.companyId,
        name: '',
        features: undefined,
        activateTime: undefined,
        expireTime: undefined,
        status: undefined,
        editName: '',

        newid: '',
        roleName: '',
        userEmail: '',
      },
      tab: '',

      error: {
        editName: null,
        activateTime: null,
        expireTime: null,

        roleName: null,
        userEmail: null,
        newid: null
      },

      saving: false
    };
  },
  computed: {
    newCompany() {
      return (this.company.id || '') === '' || this.mode === 'clone';
    },
    deleteButtonStyle() {
      const style = {};
      if (this.newCompany) {
        style.cursor = 'default';
      }
      return style;
    },
    CompanyInfoValid() {
      return Object.keys(this.error).every((k) => (this.error[k] || '') === '');
    },
    newCompanyForm: {
      get() {
        const result = {
          id: {
            value: this.company.newid,
            error: this.error.newid
          },
          roleName: {
            value: this.company.roleName,
            error: this.error.roleName
          },
          userEmail: {
            value: this.company.userEmail,
            error: this.error.userEmail
          }
        };
        return { ...this.editCompanyForm, ...result };
      },
      set(val) {
        this.company.roleName = val.roleName.value;
        this.error.roleName = val.roleName.error;

        this.company.userEmail = val.userEmail.value;
        this.error.userEmail = val.userEmail.error;

        this.company.newid = val.id.value;
        this.error.newid = val.id.error;

        this.editCompanyForm = val;
      }
    },
    editCompanyForm: {
      get() {
        const result = {
          id: {
            value: this.company.id,
            error: this.error.id
          },
          name: {
            value: this.company.editName,
            error: this.error.editName
          },
          activateTime: {
            value: this.company.activateTime,
            error: this.error.activateTime
          },
          expireTime: {
            value: this.company.expireTime,
            error: this.error.expireTime
          }
        };
        return result;
      },
      set(val) {
        this.company.editName = val.name.value;
        this.error.editName = val.name.error;

        this.company.activateTime = val.activateTime.value;
        this.error.activateTime = val.activateTime.error;

        this.company.expireTime = val.expireTime.value;
        this.error.expireTime = val.expireTime.error;
      }
    }
  },
  watch: {
    'company.features': {
      handler(newVal, oldVal) {
        if ((newVal || null) !== null && (oldVal || null) === null) {
          this.origin.features = JSON.parse(JSON.stringify(newVal));
        }
      }
    }
  },
  mounted() {
  },
  created() {
    this.LoadAsync();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    initCompany() {
      this.company.name = '';
      this.company.features = undefined;
      this.company.activateTime = undefined;
      this.company.expireTime = undefined;
      this.company.status = false;

      this.company.editName = '';
      this.company.newid = '';
      this.company.roleName = '';
      this.company.userEmail = '';
    },
    async LoadAsync() {
      await this.$loading(async () => {
        const originTab = this.tab;
        this.tab = '';
        this.initCompany();
        if ((this.company.id || '') !== '') {
          const company = await PermissionService.GetCompanyAsync(this.company.id);
          this.company.id = company.id;
          this.company.name = company.name;
          this.company.editName = this.company.name;
          this.company.activateTime = company.activateTime;
          this.company.expireTime = company.expireTime;
          this.company.status = company.status;
        }

        this.origin = { ...this.company };
        this.setTab(originTab);
      });
    },
    async setTab(originTab) {
      await this.$loading(async () => {
        await this.$nextTick(() => {
          this.tab = originTab || (this.newCompany ? 'NewCompany' : 'EditCompany');
        });
      });
    },
    validateName() {
      this.error.editName = '';
      if ((this.company.editName || '').trim().length === 0) {
        this.error.editName = this.$t('admin.companyEdit.form.name.placeholder');
      }

      if (this.company.editName.trim().length > 30) {
        this.error.editName = this.$t('admin.companyEdit.form.name.feedback.overWordLimit');
      }

      return (this.error.editName || '') === '';
    },
    validateRoleName() {
      this.error.roleName = '';
      if ((this.company.roleName || '').trim().length === 0) {
        this.error.roleName = this.$t('admin.companyEdit.form.newRoleName.placeholder');
      }

      if (this.company.roleName.trim().length > 30) {
        this.error.roleName = this.$t('admin.companyEdit.form.newRoleName.feedback.overWordLimit');
      }

      return (this.error.newRoleName || '') === '';
    },
    validateUserEmail() {
      this.error.userEmail = '';
      if ((this.company.userEmail || '').trim().length === 0) {
        this.error.userEmail = this.$t('admin.companyEdit.form.newUserEmail.placeholder');
      }

      if (!EmailValidate(this.company.userEmail)) {
        this.error.userEmail = this.$t('admin.companyEdit.form.newUserEmail.feedback.regex');
      }

      return (this.error.userEmail || '') === '';
    },
    validate() {
      return [this.validateName()].every((v) => v);
    },
    newCopmanyValidate() {
      return [this.validateName(), this.validateRoleName(), this.validateUserEmail()].every((v) => v);
    },
    async save() {
      if (this.newCompany) {
        await this.createCompany();
      } else {
        await this.updateCompany();
      }
    },
    async updateCompany() {
      if (!this.saving) {
        try {
          this.saving = true;

          if (!this.validate()) {
            return;
          }
          await this.$loading(async () => {
            try {
              await PermissionService.UpdateCompanyAsync(this.company);

              this.$notify.saveSuccess();
              await this.LoadAsync();
              this.$emit('saved');
            } catch (err) {
              this.$notify.saveFailed();
            }
          });
        } finally {
          this.saving = false;
        }
      }
    },
    async createCompany() {
      if (!this.saving) {
        try {
          this.saving = true;

          if (!this.newCopmanyValidate()) {
            return;
          }
          await this.$loading(async () => {
            try {
              const result = await PermissionService.CreateCompanyAsync(this.company);
              this.company.id = (result || {}).id;

              this.$notify.saveSuccess();
              await this.LoadAsync();
              this.$emit('saved');
            } catch (err) {
              this.$notify.saveFailed();
            }
          });
        } finally {
          this.saving = false;
        }
      }
    },
    deleteCompany() {
      if (!this.newCompany) {
        this.$emit('delete', this.company);
      }
    }
  }
};
</script>
